
import { h } from "preact";

import IconProps from "../../Icons/IconProps";

const DEFAULT_COLOR = "var(--marker-blue)";
const DEFAULT_WIDTH = 14;

export default function IconAvatarAccessoryAISparkle({
    class: cssClass,
    color,
    width = DEFAULT_WIDTH
}: IconProps) {
    const stroke = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width={width} height={width} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fff" stroke={stroke} d="M5.744 1.191c.577-.921 1.94-.922 2.517 0l.054.096.005.009.004.01.032.065.006.012.005.012 1.08 2.472.055.113c.142.256.364.46.634.578l2.442 1.066.005.002.023.009.023.01.07.035.009.005.01.004c1.07.574 1.042 2.147-.088 2.664v.001l-.012.006-.012.005-2.471 1.08-.018.007c-.294.134-.53.37-.664.665l-.007.018-1.077 2.47c-.51 1.177-2.12 1.175-2.682.1l-.006-.01-.004-.01-.034-.07-.003-.009-.004-.006-1.044-2.426a1.341 1.341 0 0 0-.686-.695v.001L1.39 8.367l-.007-.003-.007-.004-.072-.034-.01-.005-.009-.005C.202 7.74.241 6.14 1.394 5.638l2.46-1.075.13-.064a1.34 1.34 0 0 0 .575-.633l1.078-2.471.005-.012.005-.012.035-.07.004-.007.058-.103z"/>
        </svg>
    );
}
